<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-30 13:57:38
-->

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="getVipRightList"
            ></el-input>
            <el-select v-model="search.status" clearable placeholder="请选择">
              <el-option
                  v-for="item in COMMON_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="getVipRightList"
            >查询
            </el-button
            >
          </template>

          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column
                fixed
                prop="orgId"
                label="序号"
                type="index"
                width="100"
            >
            </el-table-column>
            <el-table-column prop="icon" label="ICON">
              <template slot-scope="scope">
                <el-image
                    v-if="scope.row.icon"
                    style="width: 50px; height: 50px"
                    :src="scope.row.icon"
                    fit="cover"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="code" label="标识"></el-table-column>
            <!-- <el-table-column prop="payPrice" label="价格">
              <template slot-scope="scope">
                {{ scope.row.payPrice ? `￥${scope.row.payPrice}` : "" }}
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="days" label="时间" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.days">{{
                  scope.row.days ? `${scope.row.days} 天` : ""
                }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="descr" label="说明" min-width="150"></el-table-column>
            <el-table-column prop="seq" label="序号"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="50">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('change', scope.row)"
                    plain
                    v-if="editShow"
                    size="small"
                >修改
                </el-button
                >
                <!-- <el-button
                  type="success"
                  plain
                  size="small"
                  @click="handleClick('right', scope.row)"
                  >权益</el-button
                > -->
                <el-button
                    type="primary"
                    plain
                    v-if="deleteShow"
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        :title="
        clickType == 'change'
          ? '修改会员权益'
          : clickType == 'addNext'
          ? '新增会员权益'
          : ' 会员权益'
      "
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="680px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item
              label="ICON"
              class="item"
              v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <!--图片部分-->
            <div class="screenshot">
              <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
              >
                <div
                    class="icon-close"
                    @click="removeUploading(index)"
                    v-if="isMoer"
                >
                  <i class="el-icon-close"></i>
                </div>
                <el-image
                    style="width: 65px; height: 65px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy"
                />
              </span>
              <div
                  v-loading="loading1"
                  class="up-btn"
                  style="width: 65px; height: 65px; line-height: 70px"
                  @click="getPolicy"
                  v-if="isMoer"
              >
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <input type="file" ref="file" @change="getFile"/>
          </el-form-item>
          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    clearable
                    placeholder="会员权益名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="标识" prop="code">
                <el-input
                    clearable
                    placeholder="标识必须唯一"
                    v-model="params.code"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="12">
              <el-form-item label="排序">
                <el-input
                    clearable
                    placeholder="排序序号"
                    v-model="params.seq"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="22">
              <el-form-item label="说明">
                <el-input
                    type="textarea"
                    maxlength="200" :rows="4" placeholder="最长为200个字符"
                    v-model="params.descr"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
              class="xq_editor"
              label="详情"
              v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <richText v-if="dialogVisible" :keyWord="'detail'" :params="params?params:''"></richText>
            <!--            <quill-editor-->
            <!--              ref="editorComp"-->
            <!--              class="ql-toolbar"-->
            <!--              v-model="params.detail"-->
            <!--              :options="editorOption"-->
            <!--              clearable-->
            <!--            >-->
            <!--            </quill-editor>-->
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";

import {ossUpload} from "@utils/filters/upload";
import richText from "../../components/richText.vue";

export default {
  data() {
    var checkDays = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("会员天数不能为空"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }, 500);
    };
    var checkLevel = (rule, value, callback) => {
      if (!value || value == "") {
        return callback(new Error("会员权益不能为空"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }, 500);
    };
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [{header: 1}, {header: 2}], // custom button values
              [{list: "ordered"}, {list: "bullet"}],
              [{script: "sub"}, {script: "super"}], // superscript/subscript
              [{indent: "-1"}, {indent: "+1"}], // outdent/indent
              [{direction: "rtl"}], // text direction

              // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              // [{ header: [1, 2, 3, 4, 5, 6, false] }],

              // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              // [{ font: [] }],
              [{align: []}],
              ["image",],  //"link", "video"
              // ["clean"], // remove formatting button
            ],

            handlers: {
              shadeBox: null,
              insertMetric: function () {
                //方法体
                alert(1);
              },
            },
          },
        },
      },

      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,

      loading1: false, //加载中
      loading2: false, //加载中

      //上一级展示的词语
      // dictDataSelect: "",
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      defaultProps: {
        children: "orgs",
        label: "name",
      },
      permissionData: [], //组织--菜单树
      // treeList: [],
      treeList_one: [],
      optionList: [
        {
          value: "1",
          label: "修改",
        },
        {
          value: "2",
          label: "删除",
        },
      ],
      search: {},
      // input_search: "",
      // value: "", //select1
      value1: "", //select2
      value2: true,

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          {required: true, message: "请填写名称", trigger: "change"},
          {max: 10, message: "不超过10个字符"},
        ],
        code: [
          {required: true, message: "请填写唯一标识", trigger: "change"},
        ],
        level: [
          {
            required: true,
            validator: checkLevel,
            trigger: "blur",
            type: "number",
            message: "权益不为0和空,且为数字值",
          },
        ],
        payPrice: [
          {
            required: true,
            validator: checkDays,
            message: "价格不为0和空,且为数字值",
            trigger: "blur",
          },
        ],
        days: [
          {
            required: true,
            validator: checkDays,
            trigger: "blur",
            type: "number",
            message: "权益不为0和空,且为数字值",
          },
        ],
      }, //表单验证提示

      tableData: [], //二级--组织列表
      srcList: [], //上传图片数组
      // srcListBg: [], //背景图列表
      isMoer: true,

      maxIndex: 0, //权益列表长度

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  components: {
    richText,
  },
  created() {
    this.getVipRightList();
    this.getPermissionButtonList()
    // this.getPermissionData(); //获取所有菜单权限项目
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = []
        this.srcListBg = []
        this.isMoer = true
      }
    },
  },
  methods: {

    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'vip:benefit:query') {
            this.searchShow = true
          }
          if (item.code == 'vip:benefit:add') {
            this.addShow = true
          }
          if (item.code == "vip:benefit:delete") {
            this.deleteShow = true
          }
          if (item.code == "vip:benefit:edit") {
            this.editShow = true
          }
          if(item.code == "vip:benefit:status"){
            this.statusShow = false
          }
        })
      }
    },

    /**
     *  get role List  //and table  //left menu  //search
     */
    async getVipRightList() {
      let http = "/vip/item/list";
      this.loading = true;
      //组织列表
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = []
      }
    },

    //switch状态改变 --接口
    handleSwitch(index) {
      //interface
      this.$put(`/vip/item/info/status/${this.tableData[index].code}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        this.$get(`/vip/item/info/${row.code}`).then((res) => {
          if (res.data && res.data.data != undefined) {
            this.params = res.data.data
            //修改  change
            //回显图片
            if (row.icon) {
              this.srcList = [];
              this.isMoer = false;
              this.srcList.push(row.icon);
            } else {
              this.srcList = [];
              this.isMoer = true;
            }
            this.dialogVisible = true;
          }
        })
      } else {
        //添加
        this.params = {};
        this.dialogVisible = true;
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;

        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {

          if (this.clickType == "addNext") {
            // if (this.dictDataSelect == "") passData.parentId = 0;
            // passData.orgId = "";
            if (this.srcList.length) {
              this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
            }
            const {data: resData} = await this.$post(
                "/vip/item/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getVipRightList(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改
              // console.log(this.params)
              // return
              if (this.srcList.length) {
                this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
              }
              const {data: resData} = await this.$put(
                  `/vip/item/info`,
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.getVipRightList(); //重新获取数据
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //菜单分配
            }
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/vip/item/info/${row.code}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getVipRightList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getVipRightList();
    },


    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.loading1 = true;
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one" //'more','one'
      );
      this.isMoer = false;
      this.loading1 = false;

      this.srcList = addRoutes;
      // this.params.icon = this.srcList[0];
    },
  },
};
</script>
